import "./userOrders.css";

const UserOrders = () => {
  return <div>userOrders</div>;
};

export { UserOrders };
